module.exports = __webpack_public_path__ + "img/forgot-password.30e45ff1.png";